import { makeStyles } from '@material-ui/core'
import { useEffect, useRef } from 'react'
import { UIRegionOfInterest } from '../../UIRegionOfInterest'
import { RegionOfInterestColors } from './Colors'
import { LabelToText } from '../../../../../../shared/src/data/scheduleType'

const DEFAULT_REGION_OF_INTEREST_COLOR = 'red'
const HIGHLIGHTED_REGION_OF_INTEREST_COLOR = 'yellow'

const useStyles = makeStyles({
  selectionCanvas: {
    position: 'absolute',
    zIndex: 2,
  },
})

type RegionsOfInterestDisplayLayerProps = {
  width: number
  height: number
  regionsOfInterest: UIRegionOfInterest[]
  highlighted: UIRegionOfInterest | null
  zoom: number
}

export function RegionsOfInterestDisplayLayer({
  width,
  height,
  regionsOfInterest,
  highlighted,
  zoom,
}: RegionsOfInterestDisplayLayerProps) {
  const classes = useStyles()
  const canvas = useRef<HTMLCanvasElement>(null)
  useEffect(() => {
    if (!canvas.current) return

    const context = canvas.current.getContext('2d')
    if (!context) return

    context.clearRect(0, 0, width, height)
    context.globalCompositeOperation = 'source-over'
    context.lineWidth = 3
    context.font = '14px Arial'
    context.textBaseline = 'top'
    for (const uiRegionOfInterest of regionsOfInterest) {
      const x = uiRegionOfInterest.boundingBoxInNormalizedCoordinates.min.x * width
      const y = uiRegionOfInterest.boundingBoxInNormalizedCoordinates.min.y * height
      const w = uiRegionOfInterest.boundingBoxInNormalizedCoordinates.width * width
      const h = uiRegionOfInterest.boundingBoxInNormalizedCoordinates.height * height
      const roiColor = RegionOfInterestColors[uiRegionOfInterest.label] || DEFAULT_REGION_OF_INTEREST_COLOR
      context.strokeStyle = !!highlighted && uiRegionOfInterest.id === highlighted.id
        ? HIGHLIGHTED_REGION_OF_INTEREST_COLOR
        : roiColor
      context.strokeRect(x, y, w, h)
      context.fillStyle = `${roiColor}1A`
      context.fillRect(x, y, w, h)
      context.fillStyle = 'black'
      context.fillText(LabelToText[uiRegionOfInterest.label], x, y - 18)
    }
  }, [regionsOfInterest, highlighted, height, width, zoom])

  return (
    <canvas
      className={classes.selectionCanvas}
      height={height}
      width={width}
      ref={canvas}
    />
  )
}
